// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function fatigueReducer(state = [], action) {
    switch (action.type) {
      
        case types.LOGOUT:
            return []
        default:
            return state;
    };
};
